import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'

/** Řádek nastavení: vlevo název a popis, vpravo obsah. Sekce dělí jen tenká linka. */
export const SettingsRow = ({
  title,
  description,
  action,
  children,
  className,
}: {
  title: string
  description?: ReactNode
  /** Akce vedle obsahu, např. tlačítko Nahrát */
  action?: ReactNode
  children: ReactNode
  className?: string
}) => (
  <section className={cn('grid gap-x-10 gap-y-4 border-b py-8 first:pt-2 last:border-b-0 md:grid-cols-[240px_minmax(0,1fr)]', className)}>
    <div>
      <h2 className="text-[15px] font-medium">{title}</h2>
      {description && <p className="mt-1 text-sm text-pretty text-muted-foreground">{description}</p>}
      {action && <div className="mt-3">{action}</div>}
    </div>
    <div className="grid max-w-xl content-start gap-6">{children}</div>
  </section>
)

/** Sticky lišta s uložením na konci formuláře nastavení. */
export const SettingsSaveBar = ({
  dirty,
  submitting,
  onDiscard,
  label = 'Uložit',
}: {
  dirty: boolean
  submitting: boolean
  onDiscard: () => void
  label?: string
}) => (
  <div className="sticky bottom-0 z-10 -mx-1 mt-2 flex items-center justify-end gap-3 bg-background/95 px-1 py-4 backdrop-blur supports-[backdrop-filter]:bg-background/80">
    {dirty && <span className="mr-auto text-sm text-muted-foreground">Máte neuložené změny</span>}
    {dirty && (
      <button type="button" onClick={onDiscard} className="h-9 rounded-md px-3 text-sm font-medium hover:bg-muted">
        Zahodit
      </button>
    )}
    <button
      type="submit"
      disabled={submitting}
      className="inline-flex h-9 items-center rounded-md bg-primary px-4 text-sm font-medium text-primary-foreground hover:bg-primary/90 disabled:opacity-50"
    >
      {submitting ? 'Ukládám...' : label}
    </button>
  </div>
)
